import {  Outlet } from 'react-router-dom';

export const GuestRoute = ({ component: Component, ...rest }) => {
    return  <Outlet />;
};
